




































































































    import { Component, Vue, Prop} from 'vue-property-decorator';
    import iView from 'iview';
    import Ajax from '../../../lib/ajax';
    import AbpBase from '../../../lib/abpbase';
	import Tools from '../../../lib/tools';
    import Appconst from '../../../lib/appconst';
    @Component({
        name:''
    })
    export default class Monographmanage extends AbpBase  {
        initData:any = {
            searchData: {},
            fileUrl: Appconst.fileUrl,
            tableData: {
                totalCount: 0,
                loading: true,
                title: [
                    {
                        title: '序号',
                        key: 'achieveCode',
                        align: 'center',
                        width: 150
                    },
                    {
                        title: '专著名称',
                        key: 'achieveName',
                        align: 'center',
                        minWidth: 200,
                        render: (h:any, params:any)=>{
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text'
                                    },
                                    style: {
                                        color: '#57a3f3',
                                        cursor: 'pointer',
                                    },
                                    on: {
                                        click: () => {
                                            this.ShowModal('detail', params.row);
                                        }
                                    }
                                }, params.row.achieveName)
                            ])
                        }
                    },
                    {
                        title: '作者名',
                        key: 'author',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: '出版社',
                        key: 'press',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: '出版日期',
                        key: 'pressDt',
                        align: 'center',
                        minWidth: 130,
		                render: (h:any, params:any) => {
		                	return h('Col', Tools.formatDate(params.row.pressDt, 'yyyy年MM月dd日'))
		                }
                    },
                    {
                        title: '页数',
                        key: 'pageCount',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: 'ISBN号',
                        key: 'bookNumber',
                        align: 'center',
                        minWidth: 150
                    },
                    {
                        title: '发行册数',
                        key: 'publicationNumber',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 150,
                        render: (h:any, params:any) => {
                            return h('span', [
                                h('Button', {
                                    props: {
                                        type: 'success',
                                        size: 'small'
                                    },
                                    style: {
                                        display:  params.row.canEdit ? '':'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.ShowModal('edit', params.row);
                                            console.log(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '20px',
                                        display:  params.row.canDelete ? '':'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.Delete(params.row.id);
                                        }
                                    }
                                }, '删除'),
                            ])
                        }
                    }
                ],
                content: []
            },
            defaultFileList: [],
            modalData: {
                type: '',
                status: false,
                btnSatus: true,
                loading: true,
                content: {

                }
            }
        }
        //临时文件上传成功回调
        UploadSuccess(res:any, file:any, fileList:any) {
            this.initData.modalData.content.attachs.push(res.result);
        }
        //删除文件
        async DeleteFile(res:any) {
            if(res.id){
                //已有文件
                let data:any = {
                    id: res.id
                }
                await Ajax.delete('/api/services/app/Achieve/DeleteAttachAsync', {params: data});
            }else{
                //临时文件
                await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
                this.initData.defaultFileList.splice(this.initData.formData.attachs.indexOf(res.response.result), 1);
            }
        }
        //获取列表数据
        async GetData() {
            this.initData.tableData.loading = true;
            let temp = (await Ajax.get('/api/services/app/Achieve/GetScienceByPageAsync', {params: this.initData.searchData})).data.result;
            console.log(temp)
            this.initData.tableData.content = temp.items;
            this.initData.tableData.totalCount = temp.totalCount;
            if(this.initData.tableData.content.length == 0){
                this.$Message.error('暂无数据！') 
            }
            this.initData.tableData.loading = false;
        }
        //弹窗
        ShowModal(type:any, data:any) {
            (this as any).$refs.addForm.resetFields();
            this.initData.modalData.type = type;
            if(type == 'detail'){
                this.initData.modalData.title = '专著详情';
            }else if(type == 'add'){
                this.initData.modalData.title = '专著登记';
            }else{
                this.initData.modalData.title = '专著编辑';
            }
            if(type == 'add'){
                this.initData.modalData.content = {
                    attachs:[]
                };
                this.initData.defaultFileList = [];
                this.initData.modalData.status = true;
            }else{
                Ajax.get('/api/services/app/Achieve/GetScienceDetailAsync?Id='+data.id).then((res:any)=>{
                    Object.assign(this.initData.modalData.content, res.data.result);
                    this.initData.defaultFileList = this.initData.modalData.content.attachs.map( (item:any) => {
                                                        return {
                                                            name:item.attachName,
                                                            url:item.url,
                                                            id:item.id
                                                        }
                                                    } );
                    if(this.initData.modalData.type !== 'detail') {
                        this.initData.modalData.content.attachs = [];
                    }
                    this.initData.modalData.status = true;
                })
            }
            this.initData.modalData.loading = false;
        }
        //新增
        async Add() {
            (this as any).$refs.addForm.validate(async (valid:boolean)=>{
                if(this.initData.modalData.type == 'detail'){
                    this.initData.modalData.status = false;
                    return;
                }
                if(valid){
                    this.initData.modalData.btnSatus = true;
                    if(this.initData.modalData.type == 'add'){
                        Ajax.post('/api/services/app/Achieve/CreateScienceAsync', this.initData.modalData.content).then(()=>{
                            this.$Message.success('新增成功!');
                            this.GetData();
                            this.initData.modalData.status = false;
                        }).catch( () => {
                            setTimeout(() => {
                                this.initData.modalData.btnSatus = false;
                                this.$nextTick(() => {
                                    this.initData.modalData.btnSatus = true;
                                });
                            }, 1000);
                        } )
                    }else{
                        Ajax.put('/api/services/app/Achieve/UpdateScienceAsync', this.initData.modalData.content).then(()=>{
                            this.$Message.success('修改成功!');
                            this.GetData();
                            this.initData.modalData.status = false;
                        }).catch( () => {
                            setTimeout(() => {
                                this.initData.modalData.btnSatus = false;
                                this.$nextTick(() => {
                                    this.initData.modalData.btnSatus = true;
                                });
                            }, 1000);
                        } )
                    }
                }else{                
                    setTimeout(() => {
                        this.initData.modalData.btnSatus = false;
                        this.$nextTick(() => {
                            this.initData.modalData.btnSatus = true;
                        });
                    }, 1000);
                }
            })
        }
        //删除
        async Delete(id:any) {
            this.$Modal.confirm({
                    title: '标题',
                    content: '是否删除该条数据？删除后不可恢复！',
                    onOk:async() => {
                        await Ajax.delete('/api/services/app/Achieve/DeleteAwardPrizeAsync?Id='+id);
                        this.$Message.success('删除成功!');
                        this.GetData();  
                    },
                    okText: '确定',
                    cancelText: '取消'
                });          
        }
        //分页获取数据
        ChangePage(page:any) {
            this.initData.searchData.SkipCount = page-1;
            this.GetData()
        }
        //切换每页条数
        ChangePageNum(perPage:any){
            this.initData.searchData.MaxResultCount = perPage;
            this.GetData()
        }
        //初始化
        mounted() {
            this.GetData();
        }
        Export() {
            (this as any).$root.Export(this.initData.searchData, '/api/ResearchFile/ExportAllScienceAsync', '专著列表', 'xlsx');
        }  
        //合同切换
        SwitchContract(name:any) {
            this.$router.push({
                name: name
            })
        }     
        //弹窗验证
        rules:any = {
            achieveName: [{required: true, message: '请填写专著名称', trigger: 'blur'}],
            author: [{required: true, message: '请填写作者', trigger: 'blur'}],
            press: [{required: true, message: '请填写出版社', trigger: 'blur'}],
            pressDt: [{required: true, type: 'date', message: '请填写出版日期', trigger: 'blur'}],
            pageCount: [{required: true, type: 'number', message: '请填写页数', trigger: 'blur'}],
            bookNumber: [{required: true, message: '请填写ISBN号', trigger: 'blur'}],
            publicationNumber: [{required: true, type: 'number', message: '请填写发行册数', trigger: 'blur'}]
        }
    }
